import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { SmsGateway } from './settings-sms.component';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';

export function provideSettingsElementSmsGateway(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'sms-gateway',
        name: 'SMS Gateway',
        icon: 'pi pi-send',
        component: SmsGateway,
        order: 1,
        translateName: 'SETTINGS_SMS.GATEWAY.TITLE',
        resource_key: 'smsGateways',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'integrations',
          name: 'Integrations',
          order: 2,
          translateName: 'SETTINGS.CATEGORIES.INTEGRATIONS',
        },
      },
      multi: true,
    },
  ]);
}
